import { render, staticRenderFns } from "./otpSetting.vue?vue&type=template&id=482cde74&scoped=true"
import script from "./otpSetting.vue?vue&type=script&lang=js"
export * from "./otpSetting.vue?vue&type=script&lang=js"
import style0 from "./otpSetting.vue?vue&type=style&index=0&id=482cde74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482cde74",
  null
  
)

export default component.exports